module.exports = __webpack_public_path__ + "static/media/kong.94db5d4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/peaceSharkIndex/record/images/kong.png
// module id = 1485
// module chunks = 0